import React from 'react';
import Header from 'components/header/Header';
import {
  useAllowEditSearch,
  useSearchDetails,
  useIsDirtySearchDetails,
  useIsReportsDisabled,
  useIsSavingSearch,
  useSaveSearch,
  useSearchDetailsDisacrd,
  useSearchDisplayFields,
  useSelectedSearchTargetName,
  useLatestSelectedSearchRow,
  usePerformSearch,
  useSelectedChartName,
} from 'redux/hooks/searchnFilter';
import {
  GetSnFReportsButtonsListParams,
  getReportsButtonsList,
  searchHeaderButtons,
} from './utils';
import { useHistory } from 'react-router';
import { ESearchTargetNames } from './constants';
import { useModalHandlers } from 'components/modal';
import ETreeNodeAccessRightNames from 'enums/ETreeNodeAccessRightNames';
import {
  useSaveDiscardButtons,
  UseSaveDiscardButtonsParams,
} from 'CustomHooks/useSaveDiscardButtons';
import { navigationBlockWarningMessage } from 'utils/Global';

interface Props {
  tabSelectors: React.ReactNode;
  setReRenderKeyOnDiscard: React.Dispatch<React.SetStateAction<number>>;
  setReportType: React.Dispatch<React.SetStateAction<string>>;
  chartInstance: any;
}

const SNFHeader = (props: Props) => {
  const { tabSelectors, setReRenderKeyOnDiscard, setReportType, chartInstance } = props;
  const saveSearch = useSaveSearch();
  const isSavingSearch = useIsSavingSearch();
  const isDirty = useIsDirtySearchDetails();
  const onSearchDetailsDisacrd = useSearchDetailsDisacrd();
  const displayFields = useSearchDisplayFields();
  const searchDetails = useSearchDetails();
  const allowEdits = useAllowEditSearch();
  const history = useHistory();
  const isResultTab = history.location.pathname.includes('/result');
  const isDropTab = history.location.pathname.includes('/drop');
  const isCompareTab = history.location.pathname.includes('/compare');
  const isChartTab = history.location.pathname.includes('/analytics');
  const isReportsDisabled = useIsReportsDisabled(isResultTab, isDropTab, isCompareTab);
  const selectedSearchTargetName = useSelectedSearchTargetName();
  const primarySelectedSearchRow = useLatestSelectedSearchRow();
  const performSearch = usePerformSearch();
  const { hideModal, showLoadingModal } = useModalHandlers();
  const selectedChartName = useSelectedChartName();

  const saveDiscardButtonsParams: UseSaveDiscardButtonsParams = {
    enableButtons:
      searchDetails.accessRightName === ETreeNodeAccessRightNames.Modify &&
      !isSavingSearch &&
      isDirty,
    onSave: () => saveSearch(),
    onDiscard: () => {
      setReRenderKeyOnDiscard((prv) => prv + 1);
      onSearchDetailsDisacrd();
      if (window?.location?.href.includes('treeNodeId')) {
        const url = new URL(window.location.href);
        url.searchParams.delete('treeNodeId');
        history.replace(url.pathname + url.search);
      }
    },
    isEditAllowed: allowEdits,
    navigationBlockCallback: (location) => {
      if (!isDirty) {
        return undefined;
      }
      const pathname = location?.pathname;
      if (!pathname) {
        return navigationBlockWarningMessage;
      } //in case of browser reload

      const [, firstSegment] = pathname.split('/');

      if (firstSegment !== 'snf') {
        return navigationBlockWarningMessage;
      }
    },
  };

  const SaveDiscardButtons = useSaveDiscardButtons(saveDiscardButtonsParams);

  const reportsListParams: GetSnFReportsButtonsListParams = {
    setReportType,
    selectedSearchTargetName,
  };
  const reportsList = getReportsButtonsList(reportsListParams);

  const setIsLoading = (isLoading: boolean) => {
    if (isLoading) {
      showLoadingModal('Loading...');
    } else {
      hideModal();
    }
  };
  const headerButtonParams = {
    displayFields,
    isResultTab,
    primarySelectedSearchRow,
    selectedTargetName: selectedSearchTargetName as ESearchTargetNames,
    reportsList,
    isReportsDisabled,
    performSearch,
    setIsLoading,
    chartInstance,
    isChartTab,
    selectedChartName,
  };

  return (
    <>
      <Header
        title={searchDetails.searchName}
        isNewTheme
        headerButtons={searchHeaderButtons(headerButtonParams)}
        extendedSection={tabSelectors}
        extendedActionSection={SaveDiscardButtons}
      />
    </>
  );
};

export default SNFHeader;
